module.exports = __webpack_public_path__ + "img/AdobeStock_345419205.a8f86f9f.jpeg";